module.exports = __webpack_public_path__ + "static/img/tianjian4.21481e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjian4.png
// module id = o+Gm
// module chunks = 15